/**
 * Scope context exposed by {@link MiniModal} to its descendants.
 */

import { createContext, useContext } from "react";

export interface MiniModalScopeContextValue {

    /** Requests the hosting mini-modal to close. */
    "requestClose": () => void;
}

/**
 * React context used by mini-modal children that need to dismiss the host panel.
 */
export const MiniModalScopeContext = createContext<MiniModalScopeContextValue | null>( null );

/**
 * Reads the nearest {@link MiniModalScopeContext} value when rendered inside a mini-modal.
 *
 * @returns Scope API or `null` when no provider is mounted.
 */
export const useMiniModalScope = (): MiniModalScopeContextValue | null => {
    return useContext( MiniModalScopeContext );
};
